var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrowse = function SvgBrowse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.585 2.856l-.002 1.769v8.753a2.708 2.708 0 002.708 2.709h7.18a1.876 1.876 0 01-1.768 1.25H4.291a3.958 3.958 0 01-3.958-3.958V4.625c0-.817.523-1.512 1.252-1.77zM7.94.666c.497 0 .975.198 1.326.55l3.849 3.851c.351.352.549.828.549 1.326v6.986c0 1.035-.84 1.875-1.875 1.875H4.293a1.875 1.875 0 01-1.875-1.875V2.542c0-1.036.84-1.875 1.875-1.875H7.94zm-.107 1.25h-3.54a.625.625 0 00-.625.626v10.837c0 .345.28.625.625.625h7.496c.345 0 .625-.28.625-.625V6.503H9.707a1.875 1.875 0 01-1.87-1.746l-.005-.129V1.917zm1.25.885v1.827c0 .317.235.578.54.62l.085.005h1.825L9.083 2.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrowse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/browse.bfab1ca9.svg";
export { ForwardRef as ReactComponent };